export const convertHoraString = (hora) => {
    if (!hora) return;
    const horas = hora.getHours().toString().padStart(2, '0');
    const minutos = hora.getMinutes().toString().padStart(2, '0');
    const segundos = hora.getSeconds().toString().padStart(2, '0');
    return `${horas}:${minutos}:${segundos}`;
};

export const convertFechaString = (fecha) => {
    if (!fecha) return;
    const anio = fecha.getFullYear();
    const mes = String(fecha.getMonth() + 1).padStart(2, '0');
    const dia = String(fecha.getDate()).padStart(2, '0');
    return `${anio}-${mes}-${dia}`;
};
